export const dataTypes = [
    {
        type: 'string',
        similar_type: ['text', 'character', 'character varying', 'string'],
        operators: [
            { label: '=', condition: '=', constraint: '===' },
            { label: '!=', condition: '!=', constraint: '!==' },
            { label: '>', condition: '>', constraint: '>' },
            { label: '<', condition: '<', constraint: '<' },
            { label: '>=', condition: '>=', constraint: '>=' },
            { label: '<=', condition: '<=', constraint: '<=' },
            { label: 'LIKE', condition: 'LIKE', constraint: null },
            { label: 'NOT LIKE', condition: 'NOT LIKE', constraint: null }, // ฝั่ง JS อาจจะต้องเขียน Custom Eval เพิ่ม
            { label: 'IN', condition: 'IN', constraint: 'IN', multiple: true },
            { label: 'NOT IN', condition: 'NOT IN', constraint: 'NOT IN', multiple: true }, // ฝั่ง JS อาจจะต้องเขียน Custom Eval เพิ่ม
            { label: 'IS', condition: 'IS', constraint: null },
            { label: 'IS NOT', condition: 'IS NOT', constraint: null }
        ]
    },
    {
        type: 'boolean',
        similar_type: ['boolean'],
        operators: [
            { label: '=', condition: '=', constraint: '===' },
            { label: '!=', condition: '!=', constraint: '!==' }
        ]
    },
    {
        type: 'number',
        similar_type: ['double precision', 'integer', 'bigint'],
        operators: [
            { label: '=', condition: '=', constraint: '===' },
            { label: '!=', condition: '!=', constraint: '!==' },
            { label: '>', condition: '>', constraint: '>' },
            { label: '<', condition: '<', constraint: '<' },
            { label: '>=', condition: '>=', constraint: '>=' },
            { label: '<=', condition: '<=', constraint: '<=' },
            { label: 'IN', condition: 'IN', constraint: 'IN', multiple: true },
            { label: 'NOT IN', condition: 'NOT IN', constraint: 'NOT IN', multiple: true } // ฝั่ง JS อาจจะต้องเขียน Custom Eval เพิ่ม
        ]
    },
    {
        type: 'array',
        similar_type: ['ARRAY', 'array', 'Array'],
        operators: [
            // { label: '=', condition: '=', constraint: '===', multiple: true }, // JS Eval Array ตรงๆ ยาก มักต้องใช้ Lodash isEqual จึงให้เป็น null ไปก่อน
            // { label: '!=', condition: '!=', constraint: '!==', multiple: true },
            { label: '=', condition: '=', constraint: null, multiple: true }, // JS Eval Array ตรงๆ ยาก มักต้องใช้ Lodash isEqual จึงให้เป็น null ไปก่อน
            { label: '!=', condition: '!=', constraint: null, multiple: true },
            // { label: 'includes', condition: null, constraint: 'includes' }, // ต้องปรับการแปลง l_operand,operator,r_operand ทั้ง Frontend และ G2D
            // { label: 'Contains (@>)', condition: '@>', constraint: null, multiple: true },
            // { label: 'Contained by (<@)', condition: '<@', constraint: null, multiple: true }, // ฝั่ง JS ต้องเขียนลอจิกเช็ค subset
            // { label: 'Overlaps', condition: '&&', constraint: null, multiple: true } // ฝั่ง JS ต้องเขียนลอจิกเช็ค intersection
        ]
    },
    {
        type: 'date',
        similar_type: ['Date', 'Timestamp', 'DATE', 'TIMESTAMP', 'date', 'timestamp', 'datetime', 'timestamp without time zone', 'timestamp with time zone', 'time without time zone', 'time with time zone'],
        operators: [
            { label: '=', condition: '=', constraint: '===' }, // JS Eval เรื่อง Date ต้องแปลงเป็น Time (getTime) ก่อน
            { label: '!=', condition: '!=', constraint: '!==' },
            { label: '>', condition: '>', constraint: '>' },
            { label: '<', condition: '<', constraint: '<' },
            { label: '>=', condition: '>=', constraint: '>=' },
            { label: '<=', condition: '<=', constraint: '<=' }
        ]
    }
];